/**
 * @file ルートページ（リダイレクト専用）
 *
 * 「/」アクセス時にログインページへ即座にリダイレクトする。
 * 画面表示はなく、ルーティング制御のみを行う。
 */
import { NextPage } from 'next/types';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

const Index: NextPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace('/login');
  }, [router]);

  return <div />;
};

export default Index;
